import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _pickBy from "lodash/pickBy";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { RESET_PLAID_ONBOARDING, getPortalForInstitution } from "../actions/financial-data";
import { deleteProviderAccount, loginToProvider, resetYodleeOnboarding, startYodleeOnboarding } from "../actions/yodlee";
var initialState = {
  portalsByInstitutionId: {},
  selectedPortalId: null
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case loginToProvider.SUCCESS_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedPortalId: payload.id
        });
      }

    case getPortalForInstitution.SUCCESS_TYPE:
      {
        var _payload$data;

        var portal = payload === null || payload === void 0 ? void 0 : (_payload$data = payload.data) === null || _payload$data === void 0 ? void 0 : _payload$data.financialPortalByInstitutionId;
        return _objectSpread(_objectSpread({}, state), {}, {
          portalsByInstitutionId: _objectSpread(_objectSpread({}, state.portalsByInstitutionId), {}, _defineProperty({}, portal.marketplaceInstitution.id, portal)),
          selectedPortalId: portal === null || portal === void 0 ? void 0 : portal.id
        });
      }

    case RESET_PLAID_ONBOARDING:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedPortalId: null
      });

    case deleteProviderAccount.SUCCESS_TYPE:
      {
        // If a user unlinks a portal, clear the portal cache
        return _objectSpread(_objectSpread({}, state), {}, {
          portalsByInstitutionId: _pickBy(state.portalsByInstitutionId, function (portal) {
            return portal.id !== payload.deletedPortalId;
          })
        });
      }

    case resetYodleeOnboarding.getType():
    case startYodleeOnboarding.getType():
      {
        if (payload !== null && payload !== void 0 && payload.portalId) {
          return _objectSpread(_objectSpread({}, state), {}, {
            selectedPortalId: payload.portalId
          });
        }

        return state;
      }

    default:
      return state;
  }
});